<template>
  <div class="container-fluid">
    <div class="card p-4">
      <div class="card-header pl-3 pr-3">
        <div class="d-flex justify-content-between">
          <div>
            <h5>Categories</h5>
          </div>
          <div>
            <button class="btn btn-primary" @click="create_cat = !create_cat">
              <i class="fa fa-plus"></i>
            </button>
          </div>
        </div>
      </div>
      <div class="card-body">
        <div class="tabel-responsive">
          <table class="table table-bordered" style="width: 100%">
            <thead>
              <tr>
                <th>Image</th>
                <th>Category Name</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody v-if="loading">
              <tr>
                <td class="text-center" colspan="3">
                  <sweetalert-icon icon="loading" />
                </td>
              </tr>
            </tbody>
            <tbody v-else>
              <tr v-for="ct in category" :key="ct.id">
                <td>
                  <img :src="ct.image" :alt="ct.name" width="75px" />
                </td>
                <td>{{ ct.name }}</td>
                <td>
                  <button
                    class="btn btn-warning btn-sm"
                    @click="setEditableData(ct.id, ct.name)"
                  >
                    <i class="fa fa-edit"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <!-- edit modal start -->
    <b-modal v-model="edit_cat" title="Edit Category" hide-footer="">
      <form v-on:submit.prevent="editSubmitHandler">
        <div class="form-group">
          <label for="">Category Name</label>
          <input
            type="text"
            name="category"
            class="form-control"
            placeholder="Category"
            required
            v-model="editCategory.name"
          />
        </div>
        <div class="form-group">
          <label for="">Category Image</label>
          <input
            type="file"
            name="category"
            class="form-control"
            placeholder="Select Image"
            accept="image/*"
            @change="setEditImage"
          />
        </div>
        <div class="form-group">
          <button class="btn btn-primary btn-block" disabled v-if="editLoading">
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
            Loading...
          </button>
          <button type="submit" class="btn btn-primary btn-block" v-else>
            Save Changes
          </button>
        </div>
      </form>
    </b-modal>
    <!-- edit modal end -->

    <!-- add modal start -->
    <b-modal v-model="create_cat" title="Create Category" hide-footer="">
      <form v-on:submit.prevent="createCategorySubmitHandler">
        <div class="form-group">
          <label for="">Category Name</label>
          <input
            type="text"
            name="category"
            class="form-control"
            placeholder="Category"
            v-model="newCategory.name"
            required
          />
        </div>
        <div class="form-group">
          <label for="">Category Image</label>
          <input
            type="file"
            name="category"
            class="form-control"
            placeholder="Select Image"
            accept="image/*"
            @change="getImageData"
            required
          />
        </div>
        <div class="form-group">
          <button
            class="btn btn-primary btn-block"
            disabled
            v-if="createLoading"
          >
            <span
              class="spinner-border spinner-border-sm"
              role="status"
              aria-hidden="true"
            ></span>
            Loading...
          </button>
          <button type="submit" class="btn btn-primary btn-block" v-else>
            Save
          </button>
        </div>
      </form>
    </b-modal>
    <!-- add modal end -->
  </div>
</template>

<script>
import { dbFs } from "../../modules/database";
import firebase from "firebase/app";
import "firebase/storage";

export default {
  data() {
    return {
      loading: false,
      createLoading: false,
      editLoading: false,
      category: null,
      create_cat: false,
      edit_cat: false,
      newCategory: {
        name: "",
        image: null
      },
      editCategory: {
        name: "",
        image: null,
        id: null
      }
    };
  },
  mounted() {
    this.getCategory();
  },
  methods: {
    getCategory() {
      this.loading = true;
      this.$bind("category", dbFs.collection("productCategory"))
        .then(() => {
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    getImageData(e) {
      this.newCategory.image = e.target.files[0];
    },
    setEditImage(e) {
      this.editCategory.image = e.target.files[0];
    },
    createCategorySubmitHandler() {
      this.createLoading = true;
      const storageRef = firebase
        .storage()
        .ref(`category/${this.newCategory.image.name}`)
        .put(this.newCategory.image);

      storageRef.on(
        "state_changed",
        null,
        err => {
          this.createLoading = false;
          console.log(err);
        },
        () => {
          storageRef.snapshot.ref.getDownloadURL().then(url => {
            dbFs
              .collection("productCategory")
              .add({
                name: this.newCategory.name,
                image: url,
                img: url
              })
              .then(() => {
                this.$root.toast("Category added successfully");
                this.create_cat = false;
                this.newCategory = {
                  name: "",
                  image: null
                };
                this.editLoading = false;
              })
              .catch(() => {
                this.createLoading = false;
              });
          });
        }
      );
    },
    setEditableData(id, name) {
      this.editCategory.name = name;
      this.editCategory.id = id;
      this.edit_cat = !this.edit_cat;
    },
    editSubmitHandler() {
      this.editLoading = true;
      if (this.editCategory.image !== null) {
        const storageRef = firebase
          .storage()
          .ref(`category/${this.editCategory.image.name}`)
          .put(this.editCategory.image);

        storageRef.on(
          "state_changed",
          null,
          err => {
            this.editLoading = false;
            console.log(err);
          },
          () => {
            storageRef.snapshot.ref.getDownloadURL().then(url => {
              dbFs
                .collection("productCategory")
                .doc(this.editCategory.id)
                .update({
                  name: this.editCategory.name,
                  image: url,
                  img: url
                })
                .then(() => {
                  this.$root.toast("Category updated successfully");
                  this.edit_cat = false;
                  this.editCategory = {
                    name: "",
                    image: null,
                    id: null
                  };
                  this.editLoading = false;
                })
                .catch(() => {
                  this.$root.toast("Oops something went wrong");
                  this.editLoading = false;
                });
            });
          }
        );
      } else {
        dbFs
          .collection("productCategory")
          .doc(this.editCategory.id)
          .update({
            name: this.editCategory.name
          })
          .then(() => {
            this.$root.toast("Category updated successfully");
            this.edit_cat = false;
            this.editCategory = {
              name: "",
              image: null,
              id: null
            };
            this.editLoading = false;
          })
          .catch(() => {
            this.$root.toast("Oops something went wrong");
            this.editLoading = false;
          });
      }
    }
  }
};
</script>

<style></style>
